<template>
  <div>
    <b-modal
      @ok="e => $emit('ok', e)"
      @hidden="e => $emit('hidden', e)"
      @cancel="e => $emit('cancel', e)"
      size="m"
      :id="dialogId"
      :title="dialogTitle"
      :centered="dialogVerticalCenter"
    >
      <div class="form-row">
        {{ dialogMessage }}
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          No
        </b-button>
        <b-button size="sm" variant="primary" @click="ok()">
          Yes
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    dialogId: String,
    dialogTitle: {
      type: String,
      default: "Are you sure?"
    },
    dialogMessage: {
      type: String,
      default:
        "You have made changes in the dialog. Are you sure you want to close it without saving?"
    },
    dialogVerticalCenter: {
      type: Boolean,
      default: false
    }
  },
  mounted() {},
  data() {
    return {};
  },

  computed: {},
  methods: {}
};
</script>

<style scoped></style>
